import React from 'react';
import {
    Chip,
    Divider,
    LinearProgress,
    Paper,
    Stack,
    Typography,
} from '@mui/material';
import ReportSection from './ReportSection';
import EmptyState from './EmptyState';
import { formatMoney, formatNumber, formatOrderCode, percentage, toNumber } from '../utils/formatters';

const OrderServiceValuationPanel = ({
    summary = {},
    valuationStatus = {},
    topPendingValuation = [],
}) => {
    const totalOrders = toNumber(summary.total_orders);

    const items = [
        {
            label: 'Pendiente valorizar',
            quantity: valuationStatus.finalizadas_pendientes_valorizar,
            amount: valuationStatus.amount_pendiente_valorizar,
            color: 'warning',
        },
        {
            label: 'Pendiente facturar',
            quantity: valuationStatus.valorizadas_pendientes_facturar,
            amount: valuationStatus.amount_pendiente_facturar,
            color: 'info',
        },
        {
            label: 'Pendiente cerrar',
            quantity: valuationStatus.facturadas_pendientes_cerrar,
            amount: valuationStatus.amount_pendiente_cerrar,
            color: 'secondary',
        },
        {
            label: 'Cerradas',
            quantity: valuationStatus.cerradas,
            amount: valuationStatus.amount_cerrado,
            color: 'success',
        },
    ];

    return (
        <ReportSection
            title="Valorización, facturación y cierre"
            subtitle="Control del ciclo administrativo después de la ejecución"
        >
            <Stack spacing={1.5}>
                {items.map((item) => {
                    const progress = percentage(item.quantity, totalOrders);

                    return (
                        <Paper key={item.label} variant="outlined" sx={{ p: 1.5, borderRadius: 2 }}>
                            <Stack direction="row" justifyContent="space-between" alignItems="center">
                                <Chip
                                    size="small"
                                    label={item.label}
                                    color={item.color}
                                    variant="outlined"
                                />

                                <Typography variant="body2" fontWeight={800}>
                                    {formatNumber(item.quantity)}
                                </Typography>
                            </Stack>

                            <LinearProgress
                                variant="determinate"
                                value={progress}
                                sx={{ height: 8, borderRadius: 99, my: 1 }}
                            />

                            <Typography variant="body2" fontWeight={900}>
                                {formatMoney(item.amount)}
                            </Typography>
                        </Paper>
                    );
                })}
            </Stack>

            <Divider sx={{ my: 2 }} />

            <Typography variant="subtitle2" fontWeight={900} sx={{ mb: 1 }}>
                Mayores pendientes de valorización
            </Typography>

            {topPendingValuation.length === 0 ? (
                <EmptyState text="No hay órdenes ejecutadas pendientes de valorización." />
            ) : (
                <Stack spacing={1}>
                    {topPendingValuation.slice(0, 5).map((item) => (
                        <Paper key={item.ordsercabid} variant="outlined" sx={{ p: 1.2, borderRadius: 2 }}>
                            <Stack direction="row" justifyContent="space-between" spacing={2}>
                                <div>
                                    <Typography variant="body2" fontWeight={800}>
                                        {formatOrderCode(item.ordsercabid)}
                                    </Typography>

                                    <Typography variant="caption" color="text.secondary">
                                        {item.ordsercabnom}
                                    </Typography>
                                </div>

                                <Typography variant="body2" fontWeight={900}>
                                    {formatMoney(item.ordsercabpre)}
                                </Typography>
                            </Stack>
                        </Paper>
                    ))}
                </Stack>
            )}
        </ReportSection>
    );
};

export default OrderServiceValuationPanel;